import { useTranslation } from "react-i18next";
const Label = ({label,required=false, ...restProps})=>{
    const { t } = useTranslation()
    if(!label){
        return null;
    }
    return(
        <label className="block text-sm font-semibold text-gray-900" {...restProps}>
            {t(label)}
            {required && <span className="text-red-600"> *</span>}
        </label>
    )
}

const Error = ({error, ...restProps})=>{
    if(!error){
        return null;
    }
    return(
        <span className="text-xs text-red-600" {...restProps}>{error}</span>
    )
}

const AppFieldWithLabelAndError = ({
    label,
    required=false,
    error,
    children,
    labelProps={},
    errorProps={},

})=>{
    return(
        <div className="w-full flex flex-col gap-2">
            {label && <div className="flex justify-between">
                <Label label={label} required={required} {...labelProps} />
                    
            </div>}
            {children}
            {error && <Error error={error} {...errorProps} />}
        </div>
    )
}


export {
    Label,
    Error,
    AppFieldWithLabelAndError
}